import {
  ConnectedAudiologistChainNumberStatusFilterParameter,
  ConnectedAudiologistSortByParam,
  ConnectedAudiologistSortParameter,
  GetAudiologistsOfSupplierParams,
} from "@bvhi/backend-api/apis";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { AudiologistsListView } from "../../../views/app/user/audiologists/list/audiologists-list-view";

export const Route = createFileRoute("/_main/app/audiologists/")({
  validateSearch: (search: Record<string, unknown>): GetAudiologistsOfSupplierParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as ConnectedAudiologistSortParameter) || [ConnectedAudiologistSortByParam.CHAIN_NUMBER_ASC],
      statuses: (search?.statuses as ConnectedAudiologistChainNumberStatusFilterParameter) || ["ACTIVE"],
    };
  },
  component: () =>
    WithErrorBoundary({
      Component: withPermissionCheck({ Component: AudiologistsListView }),
    }),
});
